import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { MetricDefinitionRecord } from "../MetricRecord";

export function useMetricDefinition(
  name: string | undefined,
  orgId: string | undefined,
) {
  const { metricsService } = useDomainServices();

  return useQuery<MetricDefinitionRecord, Error>({
    queryKey: ["metricDefinition", name, orgId],
    queryFn: ({ signal }) => {
      if (name === undefined) {
        return Promise.reject(new Error("Invalid metric definition name"));
      }
      return metricsService.getMetricDefinitionByName(name, {
        abortSignal: signal,
        orgId,
      });
    },
    enabled: name !== undefined && orgId !== undefined,
    staleTime: 60_000,
  });
}
